// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

import { Component, OnInit, OnDestroy, AfterViewInit, Input, TemplateRef, ViewChild, Output, EventEmitter, HostBinding } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatSnackBar, MatDialog } from '@angular/material';
import { fadeInOut } from '../../services/animations';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { AccountService } from "../../services/account.service";
import { Product } from 'src/app/models/product.model';
import * as FileSaver from 'file-saver'; 
import { DecimalPipe } from '@angular/common';
import { ExcelFisier } from 'src/app/models/ExcelFisier.model';
import { CatalogLink } from 'src/app/models/catalogLink.model';

@Component({
  selector: 'catalogLink',
  templateUrl: './catalogLink.component.html',
  styleUrls: ['./catalogLink.component.scss'],
    animations: [fadeInOut]
})

export class CatalogLinkComponent
{
  private isSaving: boolean;
  private isNew: boolean;
  catalogLinkForm: FormGroup;
  catalogLink: CatalogLink;
  definireCatalogLink: boolean = false;
  afisareCatalogLink: boolean = true;

  catalogReference: string = '';
  displayedColumns = ['actions','catalogReference', 'linkCatalogNl', 'linkCatalogFr', 'linkCatalogRo','linkCatalogEn'];
  isDataLoaded: boolean = false;
  loadingIndicator: boolean = true;
  formResetToggle: boolean = true;
  _currentUserId: string;
  data: CatalogLink[];
  dataSource: MatTableDataSource<CatalogLink>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  afiseazaDate() {
    this.loadingIndicator = true;

    let catalogReference = this.catalogReference == null || this.catalogReference == "" ? "undefined" : this.catalogReference;
    
    this.accountService
      .getCatalogLinkLists(catalogReference)
      .subscribe(results => {

        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));

        this.data = liniiReconverted;
        
        this.dataSource.data = this.data;

        this.isDataLoaded = true;

        setTimeout(() => { this.loadingIndicator = false; }, 1500);

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
        error => {
        });

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  reset() {
    this.catalogReference = '';
  }

  modificare(catalogLink: CatalogLink) {
    this.definireCatalogLink = true;
    this.afisareCatalogLink = false;
    this.catalogLink = catalogLink;
  }

  verificareStergere(catalogLink: CatalogLink) {
    this.alertService.showDialog('Delete', 'Do you confirm the deletion?', DialogType.confirm, () => this.stergeCatalogLink(catalogLink));
  }

  stergeCatalogLink(catalogLink: CatalogLink) {
    catalogLink.status = "D";
    this.accountService.saveCatalogLink(catalogLink).subscribe(
      role => {
        this.saveSuccessHelper(this.catalogLink, `Catalog deleted!`);
        this.afiseazaDate();
      },
      error => this.saveFailedHelper(error));
  }

  adaugare() {
    this.definireCatalogLink = true;
    this.afisareCatalogLink = false;
    this.catalogLink = new CatalogLink();
  }
  
  constructor(
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
  )
  {
    this.dataSource = new MatTableDataSource<CatalogLink>();
    this.buildForm();
  }

  ngOnInit() {
    this.catalogLink = new CatalogLink();
    this.afiseazaDate();
  }
  
  save() {
    if (this.catalogLinkForm.valid) {
      this.accountService.saveCatalogLink(this.catalogLink).subscribe(
        role => this.saveSuccessHelper(this.catalogLink, `Catalog saved successfully!`),
        error => this.saveFailedHelper(error));
    } else {
      alert("form invalid!");
    }
    this.afisareCatalogLink = true;
    this.definireCatalogLink = false;
  }

  private saveSuccessHelper(catalogLink?: CatalogLink, mesaj?: string) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();

    this.alertService.showMessage("Success", mesaj, MessageSeverity.success);

    this.definireCatalogLink = false;
    this.afiseazaDate();
  }

  private saveFailedHelper(error: any) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();
    this.alertService.showStickyMessage("Save Error", "Errors: ", MessageSeverity.error, error);
    this.alertService.showStickyMessage(error, null, MessageSeverity.error);
  }

  private buildForm() {
    this.catalogLinkForm = this.formBuilder.group({
      tbLinkCatalogEn: ['', [Validators.required],],
      tbLinkCatalogRo: ['', [Validators.required],],
      tbLinkCatalogNl: ['', [Validators.required],],
      tbLinkCatalogFr: ['', [Validators.required],],
      tbCatalogReference: ['', [Validators.required],]
    });
  }

  get tbCatalogReference() {
    return this.catalogLinkForm.get('tbCatalogReference');
  }

  get tbLinkCatalogEn() {
    return this.catalogLinkForm.get('tbLinkCatalogEn');
  }

  get tbLinkCatalogRo() {
    return this.catalogLinkForm.get('tbLinkCatalogRo');
  }

  get tbLinkCatalogNl() {
    return this.catalogLinkForm.get('tbLinkCatalogNl');
  }

  get tbLinkCatalogFr() {
    return this.catalogLinkForm.get('tbLinkCatalogFr');
  }

  private cancel() {
    this.definireCatalogLink = false;
    this.afisareCatalogLink = true;
    this.afiseazaDate();
  }

  private afiseazaPdfEN(catalogLink: CatalogLink) {
    window.open(catalogLink.linkCatalogEn, '_blank');
  }

  private afiseazaPdfRO(catalogLink: CatalogLink) {
    window.open(catalogLink.linkCatalogRo, '_blank');
  }

  private afiseazaPdfNL(catalogLink: CatalogLink) {
    window.open(catalogLink.linkCatalogNl, '_blank');
  }

  private afiseazaPdfFR(catalogLink: CatalogLink) {
    window.open(catalogLink.linkCatalogFr, '_blank');
  }
}
